import api from "../../components/api"

export type ReportFilters = {
  id: string,
  tenantId: number,
  reportId: number,
  name: string,
  reportTypeName: string,
  filters: string,
  deletedAtUtc: string,
  deletedBy: string,
  order: number
}

export const getFilters = async (reportTypeId: number): Promise<ReportFilters[]> => {
  return (await api.get(`/web/datacenter/report-filters/${reportTypeId}`)).data
}

export type CreateReportFilterRequest = {
  reportId: number,
  name: string,
  reportTypeName: string,
  filters: string
}

export const createFilters = async (filter: CreateReportFilterRequest): Promise<void> => {
  await api.post('/web/datacenter/report-filters', filter)
}

export const deleteFilters = async (filtersIds: string[]): Promise<void> => {
  await api.post('/web/datacenter/report-filters/delete', {
    filtersIds
  })
}

export const sortFilters = async (filtersIds: Record<string, number>[]): Promise<void> => {
  await api.post('/web/datacenter/report-filters/sort', { filtersIds })
}